import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedLeadPrimingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M16.31,12.24c-.16,0-.29.13-.29.29v.65h-3.08c-.08,0-.15.03-.2.08,0,0,0,0,0,0-.05.05-.09.12-.09.2s.04.16.09.21c.05.05.12.08.2.08h1.29c-.06.05-.1.13-.1.22v1.22l-1.85-1.07s-.08-.07-.1-.11c-.02-.04-.03-.08-.03-.11v-1.67l2.45-1.42h0s.04-.05.04-.09v-.8s0-.07-.02-.1c-.02-.05-.06-.1-.11-.13l-2.36-1.36-.83-.48s-.06-.02-.08-.01h-.02s-6.55,3.8-6.55,3.8h-.02s-.03.06-.03.09v6.52c0,.08.06.19.13.23l.83.48,2.36,1.36s.09.02.11,0h.02s5.1-2.94,5.1-2.94v2.2c0,.25.21.46.46.46h1.62c.25,0,.46-.21.46-.46v-3.86c0-.25-.21-.46-.46-.46h-.52v-1.28c0-.08-.03-.15-.09-.2,0,0-.01-.01-.02-.02h1.42v.72c0,.16.13.29.29.29h1.34l1.32,2.29c.08.14.26.16.4.14h.61v-4.96h-3.67Z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M20.23,12.18v-.02s-.02-.03-.03-.06c-.01-.02-.02-.03-.04-.05-.01-.01-.03-.03-.04-.03l-.03-.02s-.03-.01-.06-.02c-.02,0-.04,0-.06,0h-3.67c-.3,0-.55.25-.55.55v.39h-2.72c-.14,0-.27.05-.37.14l-.02.02c-.1.1-.16.24-.16.39,0,.15.06.3.17.4.1.1.23.15.37.15h.83v.74l-1.47-.85v-1.52l2.32-1.34.04-.02c.09-.05.14-.15.13-.26v-.83c0-.07-.01-.14-.04-.2-.05-.11-.13-.2-.22-.25l-3.19-1.84c-.08-.04-.16-.06-.25-.04h-.03s-.04.02-.06.03l-6.56,3.79s-.03.02-.04.02h-.02c-.1.07-.15.17-.13.26v6.55c0,.18.1.36.26.45l3.19,1.84c.06.03.12.05.19.05.05,0,.09-.01.14-.03.02,0,.04-.01.07-.03l4.71-2.72v1.76c0,.39.32.71.71.71h1.62c.39,0,.71-.32.71-.71v-3.86c0-.39-.32-.71-.71-.71h-.26v-.99h.8v.46c0,.3.25.55.55.55h.31l.51.88c.07.12.23.16.35.09.12-.07.16-.23.09-.35l-.36-.62h.29l1.25,2.16c.1.18.3.28.55.28.03,0,.05,0,.07,0h.61c.14,0,.26-.12.26-.26v-4.96s0-.04,0-.06ZM20.13,12.2h0,0ZM17.26,13.52c-.13.07-.22.19-.25.33s-.02.29.05.41l.15.25h-.89s-.03-.02-.03-.03v-1.95s.02-.03.03-.03h2.71l-1.76,1.02ZM19.72,12.69v4.26h-.38c-.1,0-.14,0-.15-.02l-1.33-2.29-.37-.65s0-.02.02-.02l2.21-1.27ZM8.31,19.47l.29-.17c.06-.03.1-.09.12-.16.02-.07,0-.13-.03-.19-.07-.12-.23-.16-.35-.09l-.27.16s-.02-.01-.03-.02l-2.22-1.28s-.01-.02-.01-.01v-4.02l1.97,1.14c.11.07.24.07.34.02.02,0,.04-.01.05-.02l3.7-2.14v1.33c0,.08.04.16.1.21.04.06.1.11.16.14l1.2.69c-.27.1-.45.36-.45.67v1.51l-4.58,2.65v-.4ZM8.31,14.15v-.39l.32-.19c.06-.03.1-.09.12-.16s0-.14-.03-.19c-.03-.06-.09-.1-.16-.12-.07-.02-.14,0-.19.03l-.29.17s-.02-.02-.03-.02l-2.86-1.65,5.96-3.44s.01,0,.02,0c.05,0,.09-.01.13-.03l3.07,1.77v.73s-6.06,3.5-6.06,3.5ZM7.8,14.23l-1.97-1.14c-.12-.07-.24-.07-.35-.01-.11.06-.17.17-.17.31v4.32c0,.18.11.36.26.45l2.23,1.29v.51l-2.93-1.69s0-.01-.01-.01c0,0,0,0,0,0v-6.23l2.94,1.7v.51ZM13.41,15.72c0-.11.09-.2.2-.2h1.62c.11,0,.2.09.2.2v3.86c0,.11-.09.2-.2.2h-1.62c-.11,0-.2-.09-.2-.2v-3.86ZM20.12,12.17h0,0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M11.05,17.3l-.45.26c-.12.07-.16.23-.09.35.05.08.13.13.22.13.05,0,.09-.01.13-.03l.45-.26c.06-.03.1-.09.12-.16.02-.07,0-.13-.03-.19-.07-.12-.23-.16-.35-.09Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M12.6,16.49c-.07-.02-.13,0-.19.03l-.45.26c-.12.07-.17.23-.09.35.05.08.13.13.22.13.04,0,.09-.01.13-.03l.45-.26c.06-.03.1-.09.12-.16s0-.13-.03-.19c-.03-.06-.09-.1-.16-.12Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M9.7,18.08l-.45.26c-.06.03-.1.09-.12.16-.02.07,0,.13.03.19.04.08.13.13.22.13.04,0,.09-.01.13-.03l.45-.26c.06-.03.1-.09.12-.16.02-.07,0-.13-.03-.19-.07-.12-.23-.16-.35-.09Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M12.43,10.79l-.45.26c-.06.03-.1.09-.12.16-.02.07,0,.13.03.19.05.08.13.13.22.13.04,0,.09-.01.13-.03l.45-.26c.06-.03.1-.09.12-.16.02-.07,0-.14-.03-.19-.07-.12-.23-.17-.35-.09Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M11.08,11.57l-.45.26c-.06.03-.1.09-.12.16-.02.07,0,.13.03.19.05.08.13.13.22.13.04,0,.09-.01.13-.03l.45-.26c.06-.03.1-.09.12-.16.02-.07,0-.14-.03-.19-.07-.12-.23-.16-.35-.09Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M13.78,10.01l-.45.26c-.12.07-.17.23-.09.35.05.08.13.13.22.13.04,0,.09-.01.13-.03l.45-.26c.12-.07.16-.23.09-.35-.07-.12-.23-.16-.35-.09Z"
			})
		] }) }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M15.43,17.8v.47c-.13.05-.25.07-.36.07-.26,0-.32,0-.55-.06h-.05c-.09-.03-.22-.06-.39-.09-.33-.06-.55,0-.67.07v-.49c.18-.07.44-.1.76-.03.17.03.3.06.39.08h.06c.21.06.24.06.44.06.13,0,.28-.05.37-.08Z"
		}), /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M11.98,13.74c.16,0,.28-.13.28-.28s-.13-.28-.28-.28h-.42c-.16,0-.28.13-.28.28s.13.28.28.28h.42Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M11,13.46c0-.16-.13-.28-.28-.28h-.42c-.16,0-.28.13-.28.28s.13.28.28.28h.42c.16,0,.28-.13.28-.28Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M9.74,13.46c0-.16-.13-.28-.28-.28h-.26c-.16,0-.28.13-.28.28s.13.28.28.28h.26c.16,0,.28-.13.28-.28Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M12,13.15s.09.04.14.04c.1,0,.19-.05.24-.14.08-.13.03-.31-.1-.39l-.36-.21c-.13-.08-.31-.03-.39.1-.08.13-.03.31.1.39l.36.21Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M10.93,12.52s.09.04.14.04c.1,0,.19-.05.24-.14.08-.13.03-.31-.1-.39l-.36-.21c-.07-.04-.14-.05-.21-.03s-.13.07-.17.13c-.04.06-.05.14-.03.21s.06.13.13.17l.36.21Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M9.85,11.88s.09.04.14.04c.1,0,.19-.05.24-.14.08-.13.03-.31-.1-.39l-.22-.13c-.07-.04-.14-.05-.21-.03-.07.02-.13.07-.17.13-.08.13-.03.31.1.39l.22.13Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M12.39,13.87c-.08-.13-.25-.18-.39-.1l-.36.21c-.06.04-.11.1-.13.17s0,.15.03.21c.05.09.14.14.24.14.05,0,.1-.01.14-.04l.36-.21c.06-.04.11-.1.13-.17.02-.07,0-.15-.03-.21Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M10.92,14.4l-.36.21c-.06.04-.11.1-.13.17s0,.15.03.21c.05.09.14.14.24.14.05,0,.1-.01.14-.04l.36-.21c.13-.08.18-.25.1-.39-.08-.13-.25-.18-.39-.1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M10.06,15.01c-.07-.02-.15,0-.21.03l-.22.13c-.13.08-.18.25-.1.39.05.09.14.14.24.14.05,0,.1-.01.14-.04l.22-.13c.13-.08.18-.25.1-.39-.04-.06-.1-.11-.17-.13Z"
			})
		] })] })
	]
});
export default SvgRedLeadPrimingSm;
